module.exports = __webpack_public_path__ + "media/images/printer/printer-ada05ec165312c771a8953f81f948e6d.svg";